import { MessageType, ScanStatus } from '../../../type';
import { RemoteFileMessage } from '../remote-file-message/RemoteFileMessage';
import { LocalFileMessage } from '../local-file-message/LocalFileMessage';
import { Box } from '@mui/material';
import {
  useAnalytics,
  METRICS_MEDIA_MESSAGE_CLICK,
  METRICS_FILE_MESSAGE_CLICK,
} from '@xolv-mybrightlink/common';
import { useCallback } from 'react';

type FileMessageProps = {
  channelGuid: string;
  messageGuid: string;
  messageType: Exclude<MessageType, 'TEXT'>;
  local?: boolean;
  url?: string;
  thumbnailUrl?: string;
  fileName?: string;
  scanStatus?: ScanStatus;
  color?: string;
};

export const FileMessage = (props: FileMessageProps) => {
  const {
    channelGuid,
    messageGuid,
    messageType,
    local,
    url,
    thumbnailUrl,
    fileName,
    scanStatus,
    color,
  } = props;

  const analytics = useAnalytics();

  const trackMediaClick = useCallback(() => {
    const action = ['IMAGE', 'VIDEO'].includes(messageType)
      ? METRICS_MEDIA_MESSAGE_CLICK
      : METRICS_FILE_MESSAGE_CLICK;
    analytics.trackAction(action);
  }, [analytics, messageType]);

  return (
    <Box onClick={trackMediaClick}>
      {local ? (
        <LocalFileMessage
          channelGuid={channelGuid}
          messageGuid={messageGuid}
          messageType={messageType}
          url={url}
          fileName={fileName}
        />
      ) : (
        <RemoteFileMessage
          color={color}
          messageType={messageType}
          url={url}
          thumbnailUrl={thumbnailUrl}
          fileName={fileName}
          scanStatus={scanStatus}
        />
      )}{' '}
    </Box>
  );
};
